import { scheduleSentryInit } from './lib/sentry.js'

scheduleSentryInit()
